import { __awaiter, __extends, __generator } from "tslib";
import { BaseStorage } from '../base-storage';
import { NOT_FOUND } from '../utils/constants';
var NullStrategy = /** @class */ (function (_super) {
    __extends(NullStrategy, _super);
    function NullStrategy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NullStrategy.prototype.setItem = function () {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    NullStrategy.prototype.getItem = function () {
        return Promise.reject(NOT_FOUND);
    };
    NullStrategy.prototype.removeItem = function () {
        return Promise.resolve();
    };
    NullStrategy.prototype.getAllItems = function () {
        return Promise.resolve({});
    };
    return NullStrategy;
}(BaseStorage));
export { NullStrategy };
//# sourceMappingURL=null-storage.js.map